import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StockSyncService {
  

  constructor(private http: HttpClient) { }

  getStorefrontSyncSettings(id:string|number):Observable<any[]>{
    return this.http.get<any[]>(`${environment.serviceApi}/StorefrontSync/${id}`);
  }
  Update(setting: any) {
    return this.http.post<any>(`${environment.serviceApi}/StorefrontSync`,setting);
  }
  EnableAll(storeFront:string){
    return this.http.post<any>(`${environment.serviceApi}/StorefrontSync/EnableAll/${storeFront}`,null);
  }
  disableAll(storeFront:string){
    return this.http.post<any>(`${environment.serviceApi}/StorefrontSync/disableAll/${storeFront}`,null);
  }
  updateUpperLimit(storeFront:string,upperLimit:number){
    return this.http.post<any>(`${environment.serviceApi}/StorefrontSync/updateUpperLimit/${storeFront}`,{limit:upperLimit});
  }
  changeNewItemSyncStatus(storeFront:string, checked: any) {
    return this.http.post<any>(`${environment.serviceApi}/StorefrontSync/updateNewItemSyncStatus/${storeFront}`,{enabaled:checked});
  }
  syncNow(itemId: any, storeFront: any) {
    return this.http.post<any>(`${environment.serviceApi}/StorefrontSync/syncnow/${storeFront}/${itemId}`,null);

  }
  getSyncEnabledItemCount(storeFront: string):Observable<any>{
    return this.http.get<any>(`${environment.serviceApi}/StorefrontSync/enabledcount/${storeFront}`);
  }
  getLatestStockSyncs(take: number = 10): Observable<any[]> {
    return this.http.get<any[]>(`${environment.serviceApi}/StorefrontSync/latest/${take}`);
  }
}
